import { Constant } from '@genial/config';
import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { emptyMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import {
  PrivatePensionEntityNormalized,
  DynamicCustomFiltersProps,
} from '../../../../../../../../store/product/types';
import { transformCustomCategories, transformCustomFilters } from '../../../../constants';
import { OperationType } from '../../../../contexts/constants';
import {
  legacyInitialApplicationFilter,
  privatePensionSettlementPeriodFilter,
} from '../../../AssetFilters/constants';
import { AssetNoticesNormalized } from '../../../AssetNotices';

import { PrivatePensionAsset } from '.';

export const privatePensionTableHead: TableHeadItemRecurse<PrivatePensionEntityNormalized>[] = [
  { title: '', flex: 0.5 },
  { title: 'Nome do fundo', orderValue: 'productNameNormalized', flex: 2 },
  { title: 'Tipo', orderValue: 'productTypeNormalized', flex: 1 },
  { title: 'Rent. Mês', orderValue: 'monthlyRentabilityNormalized', flex: 1 },
  { title: 'Rent. Ano', orderValue: 'annualRentabilityNormalized', flex: 1 },
  { title: 'Rent. 12M', orderValue: 'twelveMonthsRentabilityNormalized', flex: 1 },
  { title: 'Aplic. Min', orderValue: 'minimumApplicationNormalized', flex: 1 },
  { title: 'Aplic. Mensal Min', orderValue: 'monthlyMinimumApplicationNormalized', flex: 1 },
  { title: '' },
];

export const privatePensionConstants = {
  id: 'privatePension',
  typeGetterId: 'privatePension',
  title: 'Previdência',
  operationId: 1,
  operationName: 'Compra',
  operationType: 'buy' as OperationType,
  color: 'product.previdencia' as ColorTypes.Option,
  principalComponent: PrivatePensionAsset,
  tableHead: privatePensionTableHead,
  hideTableHead: false,
  marketStatusSelector: emptyMarketStatusQuery,
  categoriesField: 'productTypeNormalized',
  hasFilters: true,
  mountFilters: (customFilters: DynamicCustomFiltersProps): FilterModalTypes.FilterType[] => {
    return [
      ...transformCustomFilters(customFilters),
      legacyInitialApplicationFilter,
      privatePensionSettlementPeriodFilter,
    ];
  },
  hasCategories: true,
  categoriesLabel: 'Categorias',
  mountCategories: (customFilters: DynamicCustomFiltersProps) =>
    transformCustomCategories(customFilters, 'productTypeNormalized'),
  groupNotices: false,
  notices: [] as AssetNoticesNormalized[],
  hasRefresher: false,
  captions: [],
  unleashFlag: '',
  unleashFlagBatchTicket: '',
  unleashFlagCustomers: Constant.UnleashCustomersPrivatePensionToggle,
} as const;
